import { render, staticRenderFns } from "./edit-sources-modal.vue?vue&type=template&id=09e37ff5&scoped=true&"
import script from "./edit-sources-modal.vue?vue&type=script&lang=ts&"
export * from "./edit-sources-modal.vue?vue&type=script&lang=ts&"
import style0 from "./edit-sources-modal.vue?vue&type=style&index=0&id=09e37ff5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09e37ff5",
  null
  
)

export default component.exports